import React from 'react';

/**
 * MiraLogo - Mi Brand Logo Component
 * Uses the official Mi logo image for consistent branding.
 */
export default function MiraLogo({ size = 32, className = "", type = "text", hideIcon = false }) {
  if (type === "icon") {
    return (
      <div 
        className={`relative flex items-center justify-center ${className}`}
        style={{ width: size, height: size }}
      >
        <div className="relative z-10 w-full h-full p-1 border rounded-xl flex items-center justify-center"
          style={{
            background: 'rgba(10, 24, 17, 0.6)',
            borderColor: 'rgba(137,243,54,0.2)',
            backdropFilter: 'blur(4px)',
            boxShadow: '0 0 12px rgba(137,243,54,0.15)'
          }}
        >
          <img 
            src="/assets/mi/mi-pwa-icon.png" 
            alt="Mi" 
            className="w-full h-full object-contain rounded-lg"
          />
        </div>
      </div>
    );
  }

  // DEFAULT: Mi Logo + App Name (transparent background only)
  return (
    <div className={`flex items-center justify-center gap-3 ${className} select-none`}>
      {!hideIcon && (
        <img
          src="/assets/mi/mi-pwa-icon.png"
          alt="Mi"
          style={{ width: size, height: size }}
          className="object-cover rounded-xl border border-primary/30 bg-transparent"
        />
      )}
      <span
        className="font-black tracking-[0.15em] uppercase leading-none text-white"
        style={{ fontSize: Math.max(14, Math.round(size * 0.45)) }}
      >
        GAME <span className="text-[var(--mi-lime)]">PRO</span> HUB
      </span>
    </div>
  );
}


